import '../../base_builders/vertical/rcp/rcp_base_builder';

// import FavRatingsBeta from '../../../assets/vertical/rcp/2018_election/fav_ratings_beta_v6.js';
import FavRatingsBeta from '../../../assets/js/Polls/2020_Election/FavRatingsBeta/InitFavRatings.js';
FavRatingsBeta();

// import covid_totals_table from '../../../assets/vertical/rcp/covid_totals_table.js';
import InitCovid from '../../../assets/js/Covid/InitCovidApp.js';  
InitCovid();

import Home from '../../../assets/js/Sections/Home/Home.js';

import Newsletters from '../../../assets/js/Newsletters/Newsletters';
Newsletters();

/*import homepage_slides from '../../../assets/vertical/rcp/homepage_slides.js';*/
import PublicAffairsrightColumnWidget from '../../../assets/js/PublicAffairs/RightColumnWidget';
PublicAffairsrightColumnWidget();

import AccuWeather from '../../../assets/js/Widgets/AccuWeather/Accu.js';

// import alpha_widget from '../../../assets/top/fact_check_review/alpha_widget.js';
// import FactCheckWidgets from '../../../assets/js/FactCheck/HomeWidgets.js';
// FactCheckWidgets();
import FeaturedPostWidget from "../../../assets/js/PublicAffairs/FeaturedPostWidget";
FeaturedPostWidget();

// import electionNight from '../../../assets/js/election/2020/electionNight.js';
import ElectionNight from '../../../assets/js/election/2020/ElectionNight/InitElectionNight.js';
ElectionNight();

import RcLifeWidgets from '../../../assets/js/Widgets/RcLifeWidgets/RcLifeWidgets.js';
RcLifeWidgets();

//import HotJar from '../../../assets/js/Utility/HotJar';
//HotJar();

import RcpHome from '../../../assets/js/Vertical/RCP/Home.js';
RcpHome();